<template>
  <div class="settings">
    <h2 id="deviceSettings"> Device Settings: </h2>
    <v-btn :disabled="this.deviceEnabled" @click="requestAndSyncToken">
      Enable Notifications On This Device
    </v-btn>
    <h2> Global Settings: </h2>
    <span class="label">
      Notifications Enabled:
      <toggle-button :value="this.enabled" :sync="true" @change="updateEnabled"/>
    </span>
    <span class="label">
      Receive Notifications While Online:
      <toggle-button :value="this.sendWhileOnline" :sync="true" @change="updateSendWhileOnline"/>

    </span>
    <router-link id="changeKey" to="/">Change API Key</router-link>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';
import { mapGetters, mapState } from 'vuex';
import firebase from '../firebase';

const { messaging, db } = firebase;

let listener;

export default {
  data() {
    return {
      token: null,
      tokens: [],
      enabled: true,
      sendWhileOnline: true,
    };
  },
  computed: {
    ...mapState([
      'apiKey',
    ]),
    ...mapGetters([
      'apiKeySet',
    ]),
    deviceEnabled() {
      return this.tokens.includes(this.token);
    },
  },
  methods: {
    updateEnabled({ value: enabled }) {
      db.collection('accounts').doc(this.apiKey).set({
        enabled,
      }, { merge: true });
    },
    updateSendWhileOnline({ value: sendWhileOnline }) {
      db.collection('accounts').doc(this.apiKey).set({
        sendWhileOnline,
      }, { merge: true });
    },
    syncToken() {
      console.log('attempting sync');
      if (this.deviceEnabled || !this.token) return;
      console.log('syncing');
      console.log(this.tokens);
      const tokens = [...this.tokens, this.token];
      db.collection('accounts').doc(this.apiKey).set({
        tokens,
      }, { merge: true });
    },
    requestToken() {
      return messaging.getToken().then((currentToken) => {
        if (currentToken) {
          this.token = currentToken;
        } else {
          // permission denied
        }
        console.log('token set');
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
    },
    requestAndSyncToken() {
      this.requestToken().then(this.syncToken);
    },
    monitorSettings(tokenRequest) {
      listener = db.collection('accounts').doc(this.apiKey).onSnapshot((doc) => {
        if (!doc.exists) {
          console.log('creating');
          doc.ref.set({
            enabled: true,
            sendWhileOnline: false,
            tokens: this.token ? [this.token] : [],
          });
          return;
        }
        const data = doc.data();
        console.log('Current data: ', doc.data());
        this.tokens = data.tokens;
        this.enabled = data.enabled;
        this.sendWhileOnline = data.sendWhileOnline;
        tokenRequest.then(this.syncToken);
      });
    },
  },
  mounted() {
    if (!this.apiKeySet) {
      this.$router.replace('/');
      return;
    }
    const tokenRequest = this.requestToken();
    console.log('token request');
    console.log(tokenRequest);
    this.monitorSettings(tokenRequest);
    messaging.onTokenRefresh(() => {
      console.log('refreshed');
      this.requestToken();
    });
  },
  beforeDestroy() {
    if (listener) listener();
  },
  components: {
    ToggleButton,
  },
};
</script>
<style>

.settings {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

h2 {
  margin-top: 3rem;
  margin-bottom: 0.5rem;
  font-size: 1.8rem;
}

#deviceSettings {
  margin-top: 0rem;
}

.label {
  font-size: 1.2rem;
  width: 100%;
  margin-bottom: 0.3rem;
}
</style>
